import Vue from 'vue';
import trace from "./trace.mjs";
import { formatPostcode, isPostcode } from "./helpers/postcodes.mjs";
import { mediaQueryState } from "./responsive.mjs";
import { enterKeyDirective, focusDirective } from "./helpers/directives.mjs";
import { dialogBoxManager } from './dialogs/manager.mjs';
import { PostcodeSearchDialog } from './dialogs/postcode-search.mjs';

export const postcodeInputDirectives = {
    enterkey : enterKeyDirective,
    focus    : focusDirective
};

export const postcodeInputMethods = {
    onPostcodeSearch : function( event ) {
        if( !isPostcode(this.postcode) ) {
            event.preventDefault();
            trace.warn( 'Postcode input: postcode fails validation', this.postcode );

            this.postcodeMsg   = 'Please enter a valid postcode';
            this.postcodeError = true;

            return false;
        }

        this.postcode = formatPostcode( this.postcode );
        trace.info( 'Postcode input: postcode is valid', this.postcode );

        if( mediaQueryState.isMobile() ) {
            // Don't use the dialog on mobile.
            trace.info('Postcode input: redirecting to static form');
            return true;
        }

        event.preventDefault();
        return this.callPostcodeSearchDialog( this.postcode );
    },
    onPostcodeEnterKey : function( event ) {
        return this.onPostcodeSearch( event );
    },
    resetErrorState: function() {
        this.postcodeError = false;
        this.postcodeMsg   = '';
    },
    callPostcodeSearchDialog( postcode ) {
        // this is made into a hook in order to try and untangle the circular dependencies that
        // exist between this 'trait' and the components that utilise it...
        console.warn('override this in the component that inherits these methods', postcode);
    }
};

export const postcodeInputData = {
    // This data needs to match what is also present in the navigation component, as both
    // Vue components are generated from the same Blade template.
    postcode      : '',
    postcodeError : false,
    postcodeMsg   : ''
};

const postcodeBanners = document.getElementsByClassName('block-banner banner-postcode');
for( let element of postcodeBanners ) {
    new Vue({
        el         : element,
        data       : { ...postcodeInputData },
        directives : { ...postcodeInputDirectives },
        methods    : {
            ...postcodeInputMethods,
            callPostcodeSearchDialog( postcode ) {
                dialogBoxManager.pushDialog( new PostcodeSearchDialog(postcode) );
            }
        },
    })
}
